import React from 'react';
import BuildControl from '../BuildControl/BuildControl';
import classes from './BuildControls.css';


const controls=[
	{label: 'Salad' ,type: 'salad'},
	{label: 'Meat' ,type: 'meat'},
	{label: 'Cheese' ,type: 'cheese'},
	{label: 'Bacon' ,type: 'bacon'},

]

const BuildControls=(props)=>{


	return(
			<div className={classes.BuildControls}>
					<p className={classes.Price} >Price: ${parseFloat(props.price.toFixed(2))}</p>
					{controls.map(ele=>{
					return <BuildControl key={ele.label} label={ele.label} click={props.click} type={ele.type}/>
					})}

					<button className={classes.OrderButton}
					disabled={!props.purchasable}
					onClick={props.order} >{ !props.isAuth? 'Order' : 'Sign Up To Order'}</button>
			</div>
		)

}

export default BuildControls;



// WEBPACK FOOTER //
// ./src/components/BuildControls/BuildControls.jsx